<template>
<div class="chapter">
<div class="inner_page">
<p class="fm1">TO JEAN, MY WIFE</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Fm1.vue?0e2ea23d